import type { CatalogueCounty } from './types.js';

// U.S. Census Bureau TIGERweb ACS25 county catalogue.
export const INDIANA_COUNTIES: readonly CatalogueCounty[] = [
  { name: "Adams", state: "IN", fips: "18001" },
  { name: "Allen", state: "IN", fips: "18003" },
  { name: "Bartholomew", state: "IN", fips: "18005" },
  { name: "Benton", state: "IN", fips: "18007" },
  { name: "Blackford", state: "IN", fips: "18009" },
  { name: "Boone", state: "IN", fips: "18011" },
  { name: "Brown", state: "IN", fips: "18013" },
  { name: "Carroll", state: "IN", fips: "18015" },
  { name: "Cass", state: "IN", fips: "18017" },
  { name: "Clark", state: "IN", fips: "18019" },
  { name: "Clay", state: "IN", fips: "18021" },
  { name: "Clinton", state: "IN", fips: "18023" },
  { name: "Crawford", state: "IN", fips: "18025" },
  { name: "Daviess", state: "IN", fips: "18027" },
  { name: "Dearborn", state: "IN", fips: "18029" },
  { name: "Decatur", state: "IN", fips: "18031" },
  { name: "DeKalb", state: "IN", fips: "18033" },
  { name: "Delaware", state: "IN", fips: "18035" },
  { name: "Dubois", state: "IN", fips: "18037" },
  { name: "Elkhart", state: "IN", fips: "18039" },
  { name: "Fayette", state: "IN", fips: "18041" },
  { name: "Floyd", state: "IN", fips: "18043" },
  { name: "Fountain", state: "IN", fips: "18045" },
  { name: "Franklin", state: "IN", fips: "18047" },
  { name: "Fulton", state: "IN", fips: "18049" },
  { name: "Gibson", state: "IN", fips: "18051" },
  { name: "Grant", state: "IN", fips: "18053" },
  { name: "Greene", state: "IN", fips: "18055" },
  { name: "Hamilton", state: "IN", fips: "18057" },
  { name: "Hancock", state: "IN", fips: "18059" },
  { name: "Harrison", state: "IN", fips: "18061" },
  { name: "Hendricks", state: "IN", fips: "18063" },
  { name: "Henry", state: "IN", fips: "18065" },
  { name: "Howard", state: "IN", fips: "18067" },
  { name: "Huntington", state: "IN", fips: "18069" },
  { name: "Jackson", state: "IN", fips: "18071" },
  { name: "Jasper", state: "IN", fips: "18073" },
  { name: "Jay", state: "IN", fips: "18075" },
  { name: "Jefferson", state: "IN", fips: "18077" },
  { name: "Jennings", state: "IN", fips: "18079" },
  { name: "Johnson", state: "IN", fips: "18081" },
  { name: "Knox", state: "IN", fips: "18083" },
  { name: "Kosciusko", state: "IN", fips: "18085" },
  { name: "LaGrange", state: "IN", fips: "18087" },
  { name: "Lake", state: "IN", fips: "18089" },
  { name: "LaPorte", state: "IN", fips: "18091" },
  { name: "Lawrence", state: "IN", fips: "18093" },
  { name: "Madison", state: "IN", fips: "18095" },
  { name: "Marion", state: "IN", fips: "18097" },
  { name: "Marshall", state: "IN", fips: "18099" },
  { name: "Martin", state: "IN", fips: "18101" },
  { name: "Miami", state: "IN", fips: "18103" },
  { name: "Monroe", state: "IN", fips: "18105" },
  { name: "Montgomery", state: "IN", fips: "18107" },
  { name: "Morgan", state: "IN", fips: "18109" },
  { name: "Newton", state: "IN", fips: "18111" },
  { name: "Noble", state: "IN", fips: "18113" },
  { name: "Ohio", state: "IN", fips: "18115" },
  { name: "Orange", state: "IN", fips: "18117" },
  { name: "Owen", state: "IN", fips: "18119" },
  { name: "Parke", state: "IN", fips: "18121" },
  { name: "Perry", state: "IN", fips: "18123" },
  { name: "Pike", state: "IN", fips: "18125" },
  { name: "Porter", state: "IN", fips: "18127" },
  { name: "Posey", state: "IN", fips: "18129" },
  { name: "Pulaski", state: "IN", fips: "18131" },
  { name: "Putnam", state: "IN", fips: "18133" },
  { name: "Randolph", state: "IN", fips: "18135" },
  { name: "Ripley", state: "IN", fips: "18137" },
  { name: "Rush", state: "IN", fips: "18139" },
  { name: "St. Joseph", state: "IN", fips: "18141" },
  { name: "Scott", state: "IN", fips: "18143" },
  { name: "Shelby", state: "IN", fips: "18145" },
  { name: "Spencer", state: "IN", fips: "18147" },
  { name: "Starke", state: "IN", fips: "18149" },
  { name: "Steuben", state: "IN", fips: "18151" },
  { name: "Sullivan", state: "IN", fips: "18153" },
  { name: "Switzerland", state: "IN", fips: "18155" },
  { name: "Tippecanoe", state: "IN", fips: "18157" },
  { name: "Tipton", state: "IN", fips: "18159" },
  { name: "Union", state: "IN", fips: "18161" },
  { name: "Vanderburgh", state: "IN", fips: "18163" },
  { name: "Vermillion", state: "IN", fips: "18165" },
  { name: "Vigo", state: "IN", fips: "18167" },
  { name: "Wabash", state: "IN", fips: "18169" },
  { name: "Warren", state: "IN", fips: "18171" },
  { name: "Warrick", state: "IN", fips: "18173" },
  { name: "Washington", state: "IN", fips: "18175" },
  { name: "Wayne", state: "IN", fips: "18177" },
  { name: "Wells", state: "IN", fips: "18179" },
  { name: "White", state: "IN", fips: "18181" },
  { name: "Whitley", state: "IN", fips: "18183" },
];
